<div class="bg-white rounded-lg p-6 h-full min-h-[400px] flex flex-wrap items-center justify-center">
  <div class="flex items-center justify-center mb-4">
    <mat-icon [svgIcon]="'status-error'" class="[&&]:w-40 [&&]:h-40"></mat-icon>
  </div>
  <h2 class="w-full font-bold text-center mb-2 text-base md:text-2xl">{{ 'timeOut' | translate }}!</h2>
  <p class="w-full text-[#929292] text-center font-medium text-sm md:text-base">
    {{ 'didYouCompleteTheTransaction' | translate }}
  </p>
  <div class="flex justify-center mt-6 gap-4 md:gap-2 flex-wrap md:flex-nowrap">
    <app-nicky-button variant="secondary" class="text-nowrap w-full md:w-fit" (click)="userWillPayWithNewQuote()">
      {{ 'noIDidNot' | translate }}
    </app-nicky-button>
    <app-nicky-button class="text-nowrap w-full md:w-fit" (click)="userAlreadyPaid()">
      {{ 'yesICompletedTheTransaction' | translate }}
    </app-nicky-button>
  </div>
</div>
